import { InteractionStateResponse } from '@/pages/api/feedback/interaction-state';
import { useQuery } from '@tanstack/react-query';

import { routes } from '@/utils/routes';

import { getFullURL, handleResponse } from '../utils/fetcher';

export const feedbackToastQueryKey = (walletAddress: string | undefined) =>
  ['feedback-interaction-state', walletAddress] as const;

/**
 * Checks if feedback toast should be shown to the user based on 90-day cooldown.
 *
 * @param walletAddress - User's wallet address
 * @returns InteractionStateResponse with shouldShowToast boolean
 */
export const useShouldShowFeedbackToast = (walletAddress: string | undefined) =>
  useQuery<InteractionStateResponse, Error>({
    queryKey: feedbackToastQueryKey(walletAddress),
    queryFn: async () => {
      const response = await fetch(
        getFullURL(
          `${routes.api.FEEDBACK_INTERACTION_STATE}?walletAddress=${encodeURIComponent(walletAddress!)}`,
        ),
      );
      return handleResponse<InteractionStateResponse>(response);
    },
    enabled: !!walletAddress,
    refetchOnMount: 'always',
    refetchOnReconnect: false,
  });
